var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-tag',_vm._b({staticClass:"x3-tag-day",attrs:{"color":"var(--c4)"}},'van-tag',_vm.options,false),[_vm._v("按天")])}
var staticRenderFns = []

export { render, staticRenderFns }